export default __webpack_public_path__ + "assets/png/6db8c6ef90d66769f6096fb51b8c139a.png";